<template>
  <v-row class="justify-space-between">
    <v-col cols="12" md="8">
      <p style="color: #4477ad; font-size: 26px">
        {{ data.namePage }}
        <span style="margin-left: 5px">({{ getListFilter.length }})</span>
      </p>
    </v-col>
    <v-col align="end" cols="12" md="4">
      <list-billing-items-filters-component />
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import ListBillingItemsFiltersComponent from './ListBillingItemsFiltersComponent.vue'

export default {
  components: { ListBillingItemsFiltersComponent },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapState({
      getListFilter(_, getters) {
        return getters['facturacionStore/getDetailsList']
      },
    }),
    getPathStore() {
      return this.data.path + 'Store'
    },
  },
}
</script>
